export default "__VITE_ASSET__CeSCQAPv__"